<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input type="text" placeholder="Търсене" v-model="searchManHours" />
        </div>
        <span class="mck modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content">
        <div
          v-if="!manHours.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img desktop"
            src="../../assets/img/help_mh.svg"
            alt="Структура на таблицата"
          />
          <img
            class="modal-content-template-img mobile"
            src="../../assets/img/help_mh.svg"
            alt="Структура на таблицата"
          />
        </div>
        <div
          class="modal-content-item with-edit"
          v-for="(m, index) in filteredManHours"
          :key="`manHoursModal-${index}`"
          :class="{
            'modal-content-check-additional': m.isAdditional,
          }"
          :title="m.position.name"
        >
          <p>
            <span>
              {{ m.position.name }}
            </span>
            <span class="transparentish">{{ m.part }}</span>
            <span class="transparentish"> {{ m.quantity }} бр </span>
          </p>
          <span class="mck edit" @click="editManHour(index)" title>c</span>
          <span class="mck" @click="deleteManHour(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="manHours.length && !filteredManHours.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchManHours }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns">
          <button class="btn btn-excel" @click="triggerFileInput()">
            <span class="mck">E</span>
            Добави файл
          </button>
          <input
            ref="uploadManHours"
            class="input-hide"
            type="file"
            @change="handleFile"
          />
          <!--  -->
          <button class="btn btn-new" @click="save()">
            <span class="mck">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <EditManHour
      v-if="isEditManHourOpen"
      :obj="manHours[selectedIndex]"
      :parts="parts"
      @edit="handleEditManHour"
      @close="closeEditManHour"
    />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import EditManHour from './EditManHour';
export default {
  components: {
    EditManHour,
  },
  props: [
    'incomingManHours',
    'companyId',
    'projectId',
    'objectId',
    'newestManHour',
    'toggleImport',
    'parts',
  ],
  watch: {
    incomingManHours() {
      this.initManHours();
    },
  },
  data() {
    return {
      isEditManHourOpen: false,
      selectedIndex: null,
      manHours: [],
      searchManHours: '',
    };
  },
  computed: {
    filteredManHours() {
      return this.filterManHours();
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadManHours.click();
    },
    // EXCEL FILE TO JSON
   handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              // ||
              // keys[i].toLowerCase().includes('мерна единица')
              if (
                !(
                  keys[i].toLowerCase().includes('длъжност') ||
                  keys[i].toLowerCase().includes('част') ||
                  keys[i].toLowerCase().includes('чч-бр') ||
                  keys[i].toLowerCase().includes('чч') ||
                  keys[i].toLowerCase().includes('бр')
                )
              ) {
                this.$snotify.error(
                  'Таблицата трябва да има заглавен ред с Длъжност / Част / ЧЧ-бр'
                );
                return;
              }
            }
            // ROW OBJECT
            let duplicates = 0;
            for (let item in rows[row]) {
              // check for duplicate
              // const i = this.mechanizations
              //   .map((m) => m.name)
              //   .indexOf(rows[row][item][Object.keys(rows[row][item])[0]]);
              // if (i > -1) {
              //   // if there's one compare the units also and if same go to next iteration and increment counter
              //   if (
              //     this.mechanizations[i].price ===
              //     (rows[row][item][Object.keys(rows[row][item])[1]] || 0)
              //   ) {
              //     duplicates++;
              //     continue;
              //   }
              // }
              // ROW DATA

              await this.$http
                .get(
                  `${process.env.VUE_APP_BASE_URI}/position/name/${
                    rows[row][item][Object.keys(rows[row][item])[0]]
                  }`
                )
                .then((response) => {
                  const p = response.data;

                  if (p) {
                    this.manHours.push({
                      position: p,
                      part: rows[row][item][Object.keys(rows[row][item])[1]],
                      quantity:
                        rows[row][item][Object.keys(rows[row][item])[2]] || 0,
                    });
                  } else {
                    this.$snotify.error(
                      `Несъществуваща длъжност - ${
                        rows[row][item][Object.keys(rows[row][item])[0]]
                      }`
                    );
                  }
                });
            }

            if (duplicates) {
              this.$snotify.warning(
                `Игнорирани са ${duplicates} повтарящи се човекочасове`
              );
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error('Качените файлове трябва да бъдат .xls или .xlsx');
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterManHours() {
      return this.manHours.filter((m) => {
        return m.position.name
          .toLowerCase()
          .includes(this.searchManHours.toLowerCase());
      });
    },
    updateManHour(i) {
      this.$set(this.manHours, i, this.manHours[i]);
    },
    editManHour(i) {
      this.selectedIndex = i;
      this.isEditManHourOpen = true;
    },
    handleEditManHour(m) {
      // this.manHours[this.selectedIndex].position = m.position;
      this.manHours[this.selectedIndex].part = m.part;
      this.manHours[this.selectedIndex].quantity = m.quantity;

      this.$set(
        this.manHours,
        this.selectedIndex,
        this.manHours[this.selectedIndex]
      );
    },
    closeEditManHour() {
      this.isEditManHourOpen = false;
      this.selectedIndex = null;
    },
    deleteManHour(i) {
      this.manHours.splice(i, 1);
    },
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', this.manHours);
    },
    initManHours() {
      this.manHours = this.$cloneDeep(this.incomingManHours);

      this.manHours.map((m) => {
        if (!m.part) {
          m.part = '';
        }
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        // this.save();
      } else if (e.code === 'Escape') {
        this.close();
      }
    },
  },
  mounted() {
    this.initManHours();

    if (this.toggleImport) {
      this.triggerFileInput();
    }

    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEvents);
  },
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
.desktop {
  display: initial;
}
.mobile {
  display: none;
}
.modal-content-check {
  align-items: center;
}
.modal-content-item {
  height: initial;
  padding-bottom: 5px;
  padding-top: 5px;
}
.select-p {
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
}
.select-p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
